export default __webpack_public_path__ + "static/media/DeleteImages.eac88379.svg";